module.exports = __webpack_public_path__ + "img/thumb_04.1c28a830.jpg";